import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import {hideScroll} from 'src/theme/css';

import Logo from 'src/minimal-components/logo';
import {NavMiniProps, NavSectionMini} from 'src/minimal-components/nav-section';

import {NAV} from '../config-layout';
import NavToggleButton from '../common/nav-toggle-button';
import {CircularProgress} from '@mui/material';

// ----------------------------------------------------------------------

export default function NavMini({navData, isLoading,applicationName}: NavMiniProps) {
  return (
    <Box
      sx={{
        flexShrink: {lg: 0},
        width: {lg: NAV.W_MINI},
        backgroundColor: theme => theme.palette.primary.darker
      }}>
      <NavToggleButton
        sx={{
          top: 20,
          left: NAV.W_MINI - 12
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: theme => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x
        }}>
        <Logo applicationName={applicationName} sx={{mx: 'auto', my: 2}} />

        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}>
            <CircularProgress />
          </Box>
        ) : (
          <NavSectionMini data={navData} slotProps={{}} />
        )}
      </Stack>
    </Box>
  );
}
